import JsBarcode from 'jsbarcode';

export const escapeHtml = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

export const renderCode128Barcode = (
  rawValue,
  { showText = true, width = 2, height = 50, margin = 5, fontSize = 10 } = {}
) => {
  const value = String(rawValue ?? '');

  if (!value) return '';

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  try {
    JsBarcode(svg, value, {
      format: 'CODE128',
      width,
      height,
      displayValue: showText,
      fontSize,
      margin,
      text: value,
    });

    return new XMLSerializer().serializeToString(svg);
  } catch (error) {
    console.error('Failed to generate Code 128 barcode:', error);
    return '';
  }
};
